import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LotEditHistory } from '@viewbid/ts-angular-client';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'vb-lot-edit-history',
    templateUrl: './lot-edit-history.component.html',
    styleUrls: ['./lot-edit-history.component.scss'],
})
export class LotEditHistoryComponent {
    @Output() closeEditHistory: EventEmitter<void> = new EventEmitter<void>();
    @Input() lotEditHistory!: LotEditHistory[];

    constructor(private sanitizer: DomSanitizer) {}

    closeComponent(): void {
        this.closeEditHistory.emit();
    }

    sanitizeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
